import {combineReducers} from "redux";
import notifications from './notificationSlice';

const notificationReducer = combineReducers({
    notifications,
});

export default notificationReducer;